import { Component, HostBinding, Injector, Input, OnChanges, OnInit, Optional, Self, SimpleChanges } from '@angular/core';
import { NgControl, ValidationErrors } from '@angular/forms';
import { FormValidationService } from '../form-validation.service';
import './control-errors.component.scss';

@Component({
    selector: "v-control-errors",
    template: require("./control-errors.component.html")
})
export class ControlErrorsComponent implements OnInit, OnChanges {

    @Input() errors: ValidationErrors | null = null;
    @HostBinding("class.showErrors") showErrors: boolean = false;

    errorLabel: string | null = null;
    private control: NgControl | null = null;

    constructor(
        private readonly validationService: FormValidationService,
        private readonly injector: Injector,
        @Optional() @Self() private readonly ngControl: NgControl
    ) { }

    ngOnInit(): void {
        this.control = this.ngControl ?? this.injector.get(NgControl, null);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ("errors" in changes) {
            this.renderErrors();
        }

        if (this.control) {
            this.showErrors = this.control.dirty && this.control.invalid;
        } else {
            this.showErrors = true;
        }
    }

    private renderErrors(): void {
        if (!this.errors) {
            this.errorLabel = null;
            return;
        }

        this.errorLabel = this.validationService.getErrorLabel(this.errors);
    }
}
